import { Box, styled, Tab, Tabs } from '@mui/material';
import { SyntheticEvent, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import clsx from 'clsx';
import { useResize } from '../../hooks/resize';

interface Props {}

export const Books: React.FC<Props> = () => {
  const { isMobile } = useResize();
  const navigate = useNavigate();
  const location = useLocation();
  const [bookData, setBookData] = useState<any>(location.state);
  const [value, setValue] = useState<number>(1);
  const tabChange = (event: SyntheticEvent, newValue: number) => {
    const seq = bookData ? bookData.seq : '';

    setValue(1);
    navigate('bookinquire', {
      replace: true,
      state: {
        seq: seq,
      },
    });
  };
  useEffect(() => {
    if (location.state) {
      setBookData(location.state);
    }
    const path = window.location.pathname;
    setValue(1);
  }, [window.location.pathname]);

  return (
    <div className={clsx({ root: !isMobile() }, { root_resize: isMobile() })}>
      <Helmet>
        <title>도서 관리</title>
      </Helmet>
      <Outlet />
    </div>
  );
};
